export default "__VITE_ASSET__Du0m3psd__"